import React, { Fragment } from "react";
import { Link, useNavigate } from "react-router-dom";
import CustomHelmet from "../../component/reusable/Helmet";
import { FaArrowLeftLong } from "react-icons/fa6";
import ssb_gpt_1 from "../../images/howuse/ssb_gpt_1.png";
import ssb_gpt_2 from "../../images/howuse/ssb_gpt_2.png";
import ssb_gpt_3 from "../../images/howuse/ssb_gpt_3.png";
import ssb_gpt_4 from "../../images/howuse/ssb_gpt_4.png";
import ssb_gpt_5 from "../../images/howuse/ssb_gpt_5.png";
import ssb_gpt_6 from "../../images/howuse/ssb_gpt_6.png";
import ssb_gpt_7 from "../../images/howuse/ssb_gpt_7.png";
import ssb_gpt_8 from "../../images/howuse/ssb_gpt_8.png";
import ssb_gpt_9 from "../../images/howuse/ssb_gpt_9.png";
import ssb_gpt_10 from "../../images/howuse/ssb_gpt_10.jpg";
import ssb_gpt_11 from "../../images/howuse/ssb_gpt_11.png";
import ssb_gpt_12 from "../../images/howuse/ssb_gpt_12.png";
import ssb_gpt_13 from "../../images/howuse/ssb_gpt_13.png";

const SSBGPTHowUse = () => {
  const navigate = useNavigate();
  return (
    <Fragment>
      <CustomHelmet
        title="SSB-GPT: Your SSB Interview Self Preparation Tool"
        description="Prepare effectively for your SSB/AFSB/NSB/ interview with SSB-GPT, a free self-preparation tool."
      />
      {/* <GptHeader /> */}

      <section className="how_UseClassRoom_main">
        <div className="container">
          <div className="bacbtnWthHeading">
            <button
              title="back"
              className="backBtn"
              onClick={() => navigate(-1)}
            >
              <FaArrowLeftLong />
            </button>
            <h1 className="main_heading">How to use SSB GPT</h1>
          </div>
        </div>
        <div className="howUse_content container">
          <p>
            SSB-GPT is the ultimate self-preparation platform for SSB interview
            aspirants. It offers everything you need to excel in the SSB
            process, from improving your spoken English to receiving psychology
            evaluations from AI psychologists. You can practice mock interviews,
            access guidance from dedicated AI mentors, and benefit from
            specialized AI trainers, including a fitness coach, a medical
            advisor, and an English trainer. If you're preparing for the pilot
            entry, you will also get support from an AI CPSS coach. In this
            tutorial, we'll explore how to utilize SSB-GPT effectively to
            achieve the best results in your preparation journey.
          </p>
          <h2 className="subHeading">Step-by-Step Guide to Use SSB-GPT</h2>
          <h3 className="tab_heading">
            <b>Step 1.</b> Navigate to the Home Page {`>>`}{" "}
            <Link to="/chat">Ask Your AI SSB Mentor Now</Link>
          </h3>
          <img
            src={ssb_gpt_1}
            alt="ssb gpt cpss instructions"
            className="direct_banner"
          />
          <h3 className="tab_heading">
            <b>Step 2.</b> Overview of the User Interface
          </h3>
          <p>
            There is a minor change in the UI for both the desktop and mobile
            interfaces. We will review them separately, starting with the
            desktop version, followed by the mobile version.
          </p>
          <br />
          <h3 className="tab_heading">Case I: Desktop Interface</h3>

          <p style={{ color: "#f3ad6c" }}>
            <b>A. Physical Fitness Area</b>
          </p>
          <p>
            The area on the left side, marked with a red box, is the{" "}
            <b>Physical Fitness Area</b>. This section is dedicated to
            monitoring activities such as running, cycling, and various
            exercises. Let’s go through the functionality of this area step by
            step
          </p>
          <br />
          <ul style={{ listStyle: "decimal" }}>
            <li>
              <b>Exercise Modes:</b> At the top of the area, you’ll find three
              buttons that allow you to select the mode of exercise:{" "}
              <b>Running</b>, <b>Cycling</b>, or <b>Exercises</b>.
              <ul>
                <li>
                  If you choose <b>Exercises</b>, a list of 18 exercises will
                  appear.
                  <img
                    src={ssb_gpt_2}
                    alt="ssb gpt instructions"
                    className="direct_banner"
                  />
                </li>
              </ul>
            </li>
            <li>
              <b>Tutorial Button:</b> Next to the exercise button, there’s a
              <b>question mark button</b>, which opens the tutorial page.
              <ul>
                <li>
                  For example, if your physical coach asks you to perform 10
                  push-ups daily, you can click on the <b>Push-Up</b> option.
                </li>
                <li>
                  If you’re unsure how to perform a push-up, click the{" "}
                  <b>question mark button</b> to access a page with video
                  tutorials and step-by-step written instructions.
                  <img
                    src={ssb_gpt_3}
                    alt="ssb gpt instructions"
                    className="direct_banner"
                  />
                </li>
              </ul>
            </li>
            <li>
              <b>Performing Exercises:</b> Once you select an exercise (e.g.,
              push-ups), the process will unfold as follows:
              <ul>
                <li>
                  You’ll first see step-by-step instructions on how to perform
                  the exercise.
                </li>
                <li>
                  After that, your camera will activate, and you can perform the
                  exercise in front of it.
                </li>
                <li>
                  The system will detect the number of repetitions and assess
                  whether they were performed correctly or incorrectly.
                </li>
              </ul>
            </li>
          </ul>
          <p>
            We’ll explore this feature further in detail when discussing the
            role of our <b>physical coach</b>, <b>Vikram Kumar</b>, and how the
            system syncs with his guidance.
          </p>
          <p>Now, let’s move on to the other areas of the dashboard.</p>
          <br />
          <p style={{ color: "#f3ad6c" }}>
            <b>B. Binaural Music Area</b>
          </p>
          <p>
            At the bottom-left corner, you’ll find a section called{" "}
            <b>Binaural Music</b>. This feature helps the user’s mind resonate
            at specific frequencies to enhance performance.
          </p>
          <img
            src={ssb_gpt_4}
            alt="ssb gpt instructions"
            className="direct_banner"
          />
          <ul>
            <li>
              <b>For Studying:</b> Using binaural music while studying improves
              focus and concentration.
            </li>
            <li>
              <b>For Exercise:</b> Selecting exercise-specific music helps boost
              energy and optimize performance.
            </li>
          </ul>
          <br />
          <p style={{ color: "#f3ad6c" }}>
            <b>C. Classroom Area</b>
          </p>
          <p>
            The <b>center area</b> is the main section where all the action
            happens, referred to as the <b>Classroom Area</b>. Most features
            here are self-explanatory. However, users should be familiar with
            two key functionalities:
          </p>
          <img
            src={ssb_gpt_5}
            alt="ssb gpt instructions"
            className="direct_banner"
          />
          <ul style={{ listStyle: "decimal" }}>
            <li>
              <b>Mute/Unmute Teacher:</b>
              <ul>
                <li>
                  There is a button next to the teacher's profile picture that
                  allows you to mute or unmute the teacher during the session.
                </li>
              </ul>
            </li>
            <li>
              <b>Voice Typing Questions:</b>
              <ul>
                <li>
                  {" "}
                  A dedicated button enables you to use voice typing for asking
                  questions, making it easier and faster to communicate.
                </li>
              </ul>
            </li>
          </ul>
          <p>Refer to the image for clarity on these controls.</p>
          <br />
          <p style={{ color: "#f3ad6c" }}>
            <b>D. Teacher Section</b>
          </p>
          <p>
            The <b>top-right section</b> is the <b>Teacher’s Section</b>, as
            highlighted in the image with a red box. Here, you can see the
            teacher present in the classroom and the one you are interacting
            with.
          </p>
          <img
            src={ssb_gpt_6}
            alt="ssb gpt instructions"
            className="direct_banner"
          />
          <br />
          <p style={{ color: "#f3ad6c" }}>
            <b>E. Notes Area</b>
          </p>
          <p>
            In the <b>bottom-right corner</b>, you’ll find the{" "}
            <b>Notes Section</b>, where you can save all your notes in one
            place. If you’d like to learn how it works, click the{" "}
            <b>info (i)</b> button next to the Notes section. This will take you
            to a page with detailed instructions about using this feature.
          </p>
          <br />
          <h3 className="tab_heading">Case II: Mobile Interface</h3>
          <br />
          <p style={{ color: "#f3ad6c" }}>
            A. Click <b>“Ask Your AI SSB Mentor Now”</b> on the home page.
          </p>
          <img
            src={ssb_gpt_7}
            alt="ssb gpt instructions"
            className="direct_banner"
          />
          <br />
          <p style={{ color: "#f3ad6c" }}>
            B. Click the <b>'Choose Classroom'</b> button based on your study
            plan.
          </p>
          <img
            src={ssb_gpt_8}
            alt="ssb gpt instructions"
            className="direct_banner"
          />
          <img
            src={ssb_gpt_9}
            alt="ssb gpt instructions"
            className="direct_banner"
          />
          <br />
          <p style={{ color: "#f3ad6c" }}>
            C. For example, if you select <b>'Physical Trainer'</b>, you will
            first see an interface similar to the one shown in the image below.
            Before interacting with your AI Physical Trainer, Vikram Kumar,
            click on <b>'Start'</b>. (This step applies to all classrooms.)
          </p>
          <img
            src={ssb_gpt_10}
            alt="ssb gpt instructions"
            className="direct_banner"
          />
          <br />
          <p style={{ color: "#f3ad6c" }}>
            D. Once the classroom starts, you will see an interface similar to
            the image below:
          </p>
          <ul style={{ listStyle: "decimal" }}>
            <li>
              Click the button labeled <b>1</b> (marked with a rectangle) to
              switch between classes without going back.
            </li>
            <li>
              The <b>three-dot icon</b> in the top-right corner (labeled 2)
              allows you to view your profile.
            </li>
            <li>
              The section labeled <b>3</b> displays all available classes. You
              can choose any class from this list, which appears when you click
              the button labeled <b>1</b>.
            </li>
          </ul>
          <img
            src={ssb_gpt_11}
            alt="ssb gpt instructions"
            className="direct_banner"
          />
          <img
            src={ssb_gpt_12}
            alt="ssb gpt instructions"
            className="direct_banner"
          />
          <p>Now, let’s explore some more options:</p>
          <ul>
            <li>
              In the <b>top-right corner</b>, you’ll see the teacher you’re
              interacting with.
            </li>
            <li>
              Just below the teacher’s image is the <b>speaker toggle button</b>
              , labeled <b>1</b>, to turn the speaker on or off.
            </li>
            <li>
              <b>2</b> is the <b>Exercise button</b>, and
            </li>
            <li>
              <b>3</b> is the <b>Notes button</b>.
            </li>
          </ul>
          <br />
          <p style={{ color: "#f3ad6c" }}>
            E. Clicking on the <b>Exercise button</b> will take you to the{" "}
            <b>Physical and Binaural Music</b> section.
          </p>
          <ul style={{ listStyle: "decimal" }}>
            <li>
              <b>Binaural Music</b> helps the user’s mind resonate at specific
              frequencies to enhance performance.
              <ul>
                <li>
                  <b>For Studying:</b> Using binaural music while studying
                  improves focus and concentration.
                </li>
                <li>
                  <b>For Exercise:</b> Selecting exercise-specific music helps
                  boost energy and optimize performance.
                </li>
              </ul>
              If you want to learn more about the science behind binaural music,
              click the info (i) button next to the Binaural Music section. This
              will take you to a detailed page explaining the concept and
              benefits of binaural music.
            </li>
            <li>
              <b>Physical Section:</b>
              <ul>
                <li>
                  At the top of the area, you’ll find three buttons that allow
                  you to select the mode of exercise: <b>Running</b>,{" "}
                  <b>Cycling</b>, or <b>Exercise</b>.
                  <ul>
                    <li>
                      If you choose Exercises, a list of 18 exercises will
                      appear.
                      <img
                        src={ssb_gpt_13}
                        alt="ssb gpt instructions"
                        className="direct_banner"
                      />
                    </li>
                  </ul>
                </li>
                <li>
                  <b>Tutorial Button:</b> Next to the exercise button, there’s a
                  question mark button, which opens the tutorial page.
                  <ul>
                    <li>
                      For example, if your physical coach asks you to perform 10
                      push-ups daily, you can click on the <b>Push-Up</b>{" "}
                      option.
                    </li>
                    <li>
                      If you’re unsure how to perform a push-up, click the{" "}
                      <b>question mark button</b> to access a page with video
                      tutorials and step-by-step written instructions.
                    </li>
                  </ul>
                </li>
                <li>
                  <b>Performing Exercises:</b> Once you select an exercise
                  (e.g., push-ups), the process will unfold as follows:
                  <ul>
                    <li>
                      You’ll first see step-by-step instructions on how to
                      perform the exercise.
                    </li>
                    <li>
                      After that, your camera will activate, and you can perform
                      the exercise in front of it.
                    </li>
                    <li>
                      The system will detect the number of repetitions and
                      assess whether they were performed correctly or
                      incorrectly.
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
          <p>
            We’ll explore this feature further in detail when discussing the
            role of our <b>physical coach</b>, <b>Vikram Kumar</b>, and how the
            system syncs with his guidance.
          </p>
          <br />
          <p>
            Follow these steps to ensure a smooth and productive SSB interview
            preparation journey. If you need further assistance, don’t hesitate
            to reach out to support.
          </p>
          <br />
          <p>
            Jai Hind! <br />
            Over and out!
          </p>
        </div>
      </section>
      {/* <Footer /> */}
    </Fragment>
  );
};

export default SSBGPTHowUse;
